export default "__VITE_ASSET__CevNGQZT__"